<template>
  
</template>

<script>

  export default {
  
    computed: {
     
    },

    watch: {
     
    },

    created () {
     
    },

    methods: {
    }
  }
</script>

<style  lang="scss">


  

 
</style>